import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class BannerCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-banner"
        this.sliderNextSelector = "carousel-banner-next"
        this.sliderPrevSelector = "carousel-banner-prev"
        this.swiperSlider = null
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            this.swiperSlider = new Swiper(item, {
                slidesPerView: 1,
                spaceBetween: 20,
                // navigation: {
                //     nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                //     prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                // },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.015,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 1,
                        // slidesPerView: 1.015,
                        spaceBetween: 20,
                    },
                },
            })
            item.querySelectorAll(`.carousel-banner-journal-btn-next`).forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault()
                    if(!btn.classList.contains('carousel-banner-journal-btn-disable')) {
                        this.swiperSlider.slideNext();
                    }
                })
            })
            item.querySelectorAll(`.carousel-banner-journal-btn-prev`).forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault()
                    if(!btn.classList.contains('carousel-banner-journal-btn-disable')) {
                        this.swiperSlider.slidePrev();
                    }
                })
            })
        })
    }
})()
